<template>
    <svg
        :class="{
            'icon__facebook': hoverState == true
        }"
        width="11"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="facebookIconTitle"
    >
        <title id="facebookIconTitle">Facebook logo</title>
        <path
            d="M6.74 20v-9.12H9.8l.46-3.56H6.74V5.05C6.74 4 7 3.32 8.5 3.32h1.89V.14A26.377 26.377 0 0 0 7.64 0C4.93 0 3.07 1.66 3.07 4.7v2.62H0v3.56h3.07V20h3.67z"
            fill="#F2F2F2"
            fill-rule="evenodd"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconFacebook',
    props: {
        hoverState: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__facebook {
    path {
        transition: all 0.3s ease;
    }
    &:hover {
        path {
            fill: $primary;
        }
    }
}
</style>
